<template>
  <!-- <main id="page-wrap" v-if="ad.photos" class="bostad-wrap" :style="modalStyle"> -->
  <main id="page-wrap" :key="routeKey" class="bostad-wrap" :class="modalStyle">
    <div v-if="adLoaded">
      <!-- Not on an archived listing: the map picture in the photo's place is enough -->
      <map-view v-if="!ad.archived" :ad="ad" :current-flat="showFlat" @toggleflat="toggleflat" />
      <!-- the map container had a 10px bottom margin; keep that air above the content -->
      <div v-else class="archived-top-space" />
      <div v-if="opener == 'modal'" class="grid-x grid-margin-x closebar" style="margin-bottom:10px;margin-top:-10px;padding:10px 0;argin-left: 0;margin-right: 0;padding-left: 0;padding-right: 0">
        <div class="cell small-12 ">
          <div class="grid-container">
            <div class="grid-x grid-margin-x">
              <div v-if="!thisMatch && !ad.archived" class="cell small-12 share-url show-for-small-only">
                <input type="text" readonly :value="shareURL"
                        class="skipbb"
                       v-clipboard:copy="shareURL" v-tooltip.click="{content:'Kopierad! 📋', delay: 1000}"
                       @focus="$event.target.select()">
              </div>

              <div class="cell medium-8 show-for-medium">
                <button class="button facebook" @click.prevent="FBShare">
                  Dela på facebook
                </button>

                <!-- {{shareURL}} -->

                <!-- <div class="container">
    <input type="text" v-model="shareURL">
    <button type="button" class="button"
      v-clipboard:copy="shareURL"
      v-tooltip.click="{content:'Länken är kopierad!', delay: 3000}"
      >Kopiera länken</button>
  </div> -->
              </div>
              <div class="cell small-12 medium-4">
                <div style="float:right;">
                  <button class="button" @click.prevent="$emit('closeModal')">
                    Stäng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="grid-container" :class="{'extra-bottom' : opener == 'modal'}"> -->
      <div class="grid-container extra-bottom">
        <div v-if="ad.type == 21" class="grid-x">
          <div v-for="(flat, index) in ad.flats" :key="flat.id" class="cell small-12 medium-6 flatswitcher" :class="{active:showFlat == index}" @click="showFlat = index">
            <!-- <label><input v-model="showFlat" type="radio" name="showFlat" :value="index">Lägenhet {{ index+1 }} av 2 {{ flat.street }} {{ flat.street_number }}</label> -->

            <p>Lägenhet {{ index+1 }} av 2: {{ flat.street }} {{ flat.street_number }}</p>
          </div>
        </div>
        <div class="grid-x grid-margin-x">
          <div v-if="!user && !ad.archived" class="cell small-12 not-a-member" data-nosnippet>
            <div class="grid-x grid-margin-x">
              <h2>Är du intresserad av denna bostaden?</h2>
              <p>Detta är en annons för ett bostadsbyte. För att kunna byta din bostad mot denna måste du ha ett förstahandskontrakt, samt vara medlem här på sajten.</p>
              <p>
                Medlem blir du genom att klicka på <router-link :to="{name: 'create-ad'}">
                  Lägg in annons
                </router-link>
              </p>
            </div>
          </div>

          <div v-if="thisMatch" class="cell small-12 this-is-a-match">
            <div class="grid-x grid-margin-x">
              <div class="cell small-12 medium-6">
                <h3>Du har ett <span v-if="thisMatch.depth == 'direct'">direktbyte</span><span v-if="thisMatch.depth == 'triangle'">triangelbyte</span> med denna bostaden!</h3>

                <div class="share-url">
                  <input type="text" readonly :value="shareURL"
                  class="skipbb"
                         v-clipboard:copy="shareURL" v-tooltip.click="{content:'Kopierad! 📋', delay: 1000}"
                         @focus="$event.target.select()">
                </div>

                <template v-if="thisMatch.depth == 'direct'">
                  <p>Du har ett direktbyte med denna annons, innehavaren är intresserad av din bostad.</p>
                  <p>För att gå vidare i bytesprocessen skall du höra av dig till {{ thisMatch.owner.firstname }}</p>
                  <ol>
                    <li>Bjud in {{ thisMatch.owner.firstname }} att komma på visning i din bostad</li>
                    <li>Bestäm en tid då du kan komma på visning hos {{ thisMatch.owner.firstname }}</li>
                    <li>Om ni efter visningen fortfarande är intresserade av ett byte skall ni kontakta era hyresvärdar och informera om detta samt lämna in en ansökan om byte.</li>
                  </ol>
                </template>

                <template v-if="thisMatch.depth == 'triangle'">
                  <p>Du har ett triangelbyte med denna annonsen. Ett triangelbyte innebär att du flyttar in i denna bostaden, den som bor i den flyttar in i någon av de möjliga matchningarna, och den som bor där flyttar in i din bostad.</p>
                  <p>För att gå vidare i bytesprocessen skall du höra av dig till {{ thisMatch.owner.firstname }}</p>
                  <ol>
                    <li>Bestäm en tid då du kan komma på visning hos {{ thisMatch.owner.firstname }}</li>
                    <li>Bjud in dom som tackat ja till din bostad för att visa den</li>
                    <li>När ni har en bytestriangel klar så lämnar ni in en bytesansökan till era hyresvärdar</li>
                  </ol>
                </template>

                <h3>Är du inte längre intresserad?</h3>
                <button class="button-large secondary" @click.prevent="removeMatch">
                  Ta bort detta byte
                </button>
              </div>
              <div class="cell small-12 medium-6 contact-info">
                <div style="width:100%;">
                  <h3>Kontaktuppgifter för denna bostad</h3>

                  <table class="responsive-card-table unstriped" style="width:100%;">
                    <thead>
                      <tr>
                        <th>Namn</th>
                        <th>Epost</th>
                        <th>Telefon</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-label="Namn">
                          {{ thisMatch.owner.firstname }} {{ thisMatch.owner.lastname }}
                        </td>
                        <td data-label="Epost">
                          <a :href="'mailto:'+thisMatch.owner.email">{{ thisMatch.owner.email }}</a>
                        </td>
                        <td data-label="Telefon">
                          {{ thisMatch.owner.phone }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div v-if="thisMatch.depth=='direct'" style="text-align:center;">
                    <img src="/img/direktbyte.svg" alt="Direktbyte">
                  </div>

                  <div v-if="thisMatch.depth=='triangle'" style="text-align:center;">
                    <img src="/img/triangelbyte.svg" alt="Triangelbyte">
                  </div>
                  <!--
  <p>Namn: {{thisMatch.owner.firstname}} {{thisMatch.owner.lastname}}</p>
<p v-if="thisMatch.owner.phone">Telefon: {{thisMatch.owner.phone}}</p>
<p v-if="thisMatch.owner.email">Epost: {{thisMatch.owner.email}}</p> -->

                  <template v-if="thisMatch.depth=='triangle'">
                    <h3>Följande personer är intresserade av din bostad</h3>

                    <table class="responsive-card-table unstriped" style="width:100%;">
                      <thead>
                        <tr>
                          <th>Namn</th>
                          <th>Epost</th>
                          <th>Telefon</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="match in thisMatch.from_ad_ids" :key="match.id">
                          <td data-label="Namn">
                            {{ match.contact.firstname }} {{ match.contact.lastname }}
                          </td>
                          <td data-label="Epost">
                            <a :href="'mailto:'+match.contact.email">{{ match.contact.email }}</a>
                          </td>
                          <td data-label="Telefon">
                            {{ match.contact.phone }}
                          </td>
                        </tr>
                        <!-- <tr>
      <td data-label="First Name">Peter</td>
      <td data-label="Last Name">Parker</td>
      <td data-label="Hero Title">Spiderman</td>
    </tr>
    <tr>
      <td data-label="First Name">Bruce</td>
      <td data-label="Last Name">Banner</td>
      <td data-label="Hero Title">The Hulk</td>
    </tr>
    <tr>
      <td data-label="First Name">Clark</td>
      <td data-label="Last Name">Kent</td>
      <td data-label="Hero Title">Superman</td>
    </tr> -->
                      </tbody>
                    </table>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- Main -->
          <!-- <select v-model="showFlat">
            <option :key="flat.id" :value="index" />
          </select> -->

          <Flat v-if="currentFlat" :key="currentFlat.id" :flat="currentFlat" :ad="ad" :adid="ad.id" @closeModal="$emit('closeModal')" @likecard="$emit('likecard')"
                @passcard="$emit('passcard')" @updateflat="getAd(ad.id)" />

          <!-- Side -->
          <div class="cell small-12 medium-4">
            <div sticky-container class="sticky-container">
              <div
                v-sticky="window.width > 640"
                sticky-offset="offset"
                sticky-side="top"
                class="sticky-inner">
                <aside class="sidebar-wrap">
                  <div v-if="!thisMatch && !ad.archived" class="share-url show-for-medium">
                    <input type="text" readonly :value="shareURL"
                    class="skipbb"
                           v-clipboard:copy="shareURL" v-tooltip.click="{content:'Kopierad! 📋', delay: 1000}"
                           @focus="$event.target.select()">
                  </div>

                  <FlatDetails v-if="currentFlat" :key="currentFlat.id" :flat="currentFlat" :ad="ad" />
                  <!-- sidebar-content : END -->
                  <!-- Like & Dislike -->

                  <!-- An archived listing (the owner has moved) is kept as a page, but is not part of any swap:
                       no voting on it. Guests see the page exactly as before; only logged-in visitors get the notice. -->
                  <div v-if="ad.archived && user" class="archived-notice">
                    <strong>Denna bostad är inte tillgänglig just nu</strong>
                  </div>
                  <template v-if="!ad.mine && !thisMatch && !ad.archived">
                    <CardLikeButtons
                      v-if="user"
                      class="ad-controls"
                      :active="interest"
                      @likecard="likecard"
                      @passcard="passcard" />

                    <!-- <button @click.prevent="likeOrPass">
                      {{ getLikeStatus }} Testknapp {{ myActiveAd }}
                    </button> -->

                    <!-- <h3 v-if="!user">Du måste vara medlem</h3> -->
                    <!-- Like & Dislike : END -->
                  </template>
                  <template v-if="ad.mine && user">
                    <div class="grid-x grid-margin-x">
                      <!-- <div class="cell small-12">
                      <button class="button-large secondary">
                        Redigera bostad
                      </button>
                    </div> -->
                      <div v-if="!ad.archived" class="cell small-12">
                        <button
                          class="button-large secondary"
                          @click.prevent="editPhotos">
                          <span v-if="currentFlat && currentFlat.photos.length">Redigera bilder</span>
                          <span v-else>Ladda upp bilder</span>
                        </button>
                      </div>
                      <div class="cell small-12">
                        <button
                          class="button-frameless"
                          @click.prevent="deleteAd(ad.id)">
                          Radera min annons
                        </button>
                      </div>
                    </div>

                    <!--
                  <pre>{{ ad.active }}</pre>
                  <p>
                    Annonsen är aktiv:
                    <ToggleButton
                      :value="ad.active"
                      color="#82C7EB"
                      :sync="true"
                      :labels="{
                        checked: 'Ja',
                        unchecked: 'Nej︎'
                      }"
                    />
                  </p>
                  -->
                  </template>
                </aside>
              </div>
            </div>
          </div>
        </div>
        <!-- An archived listing: something to go on to, for the visitor who came from a search engine -->
        <NearbyListings v-if="ad.archived" :listings="ad.nearby" />
      </div>
    </div>
  </main>
</template>

<script>
import AdService from '@/services/AdService.js'
import L from 'leaflet'

// import PhotoGrid from '@/components/PhotoGrid.vue'

import CardLikeButtons from '@/components/CardLikeButtons.vue'
import NearbyListings from '@/components/NearbyListings.vue'
import MapView from '@/components/MapView.vue'

// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
// import { setTimeout } from 'timers'

import Flat from '@/components/Flat.vue'
import FlatDetails from '@/components/FlatDetails.vue'

import { mapState, mapGetters } from 'vuex'

const tileProviders = [
  {
    name: 'Wikimedia',
    visible: false,
    url: 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="https://foundation.wikimedia.org/wiki/Maps_Terms_of_Use">Wikimedia maps</a>'
  },
  {
    name: 'Cartodb',
    visible: true,
    url:
      'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png',
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
  },
  {
    name: 'OSM',
    visible: false,
    url: 'http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://hot.openstreetmap.org/">Humanitarian OpenStreetMap Team</a>'
  }
]

// The listing page_server.php put into the page (<script id="bb-listing">, the API's guest
// answer), once: only for the id it was rendered for, and removed after use so a later
// in-app navigation never sees a stale copy. null when there is none.
function takeEmbeddedListing(id) {
  const el = document.getElementById('bb-listing')
  if (!el) {
    return null
  }
  el.parentNode.removeChild(el)
  try {
    const embedded = JSON.parse(el.textContent)
    return embedded && String(embedded.id) === String(id) && embedded.data ? embedded.data : null
  } catch (e) {
    return null
  }
}

// import Uploader from '@/components/Uploader.vue'

export default {
  components: {
    // LMap,
    // LTileLayer,
    // LMarker,
    // PhotoGrid,
    CardLikeButtons,
    NearbyListings,
    Flat,
    FlatDetails,
    MapView
  },
  props: {
    opener: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    showMap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

      routeKey: '',
      window: {
        width: 0,
        height: 0
      },
      // adTitle: '',
      interest: false,
      like: false,
      pass: false,
      offset: { top: 84 },
      files: [],
      showFlat: 0,
      signature: {},
      // adExtras,
      adLoaded: false,
      ad: { flats: [] },
      center: { lat: 51.505, lng: -0.09 },
      opacity: 0.6,
      token: 'your token if using mapbox',
      mapOptions: {
        zoomControl: true,
        attributionControl: true,
        zoomSnap: true,
        scrollWheelZoom: false,
        dragging: true,
        tap: false,
        noBlockingAnimations: true
      },
      zoom: 13,
      minZoom: 1,
      maxZoom: 20,
      zoomPosition: 'topleft',
      attributionPosition: 'bottomright',
      layersPosition: 'topright',
      attributionPrefix: 'Vue2Leaflet',
      imperial: false,
      Positions: ['topleft', 'topright', 'bottomleft', 'bottomright'],

      icon: L.icon({
        iconUrl: '/img/marker.svg',
        iconSize: [35, 44],
        iconAnchor: [17.5, 44]
      }),
      tileProviders: tileProviders
    }
  },

  computed: {
    ...mapState(['adDetails']),
    ...mapGetters(['matches', 'user', 'myAds', 'myActiveAd']),

    thisMatch() {
      return this.matches.filter(match => match.to_ad_id === this.id)[0]
    },

    adTitle() {
      if (this.ad && this.ad.flats && this.ad.flats.length > 0) {
        var flat = this.ad.flats[this.showFlat]
        // Byte for byte the title page_server.php puts in the first-pass HTML (space before ㎡,
        // no " - BytBostad") – the rendered and the raw title must be the same one.
        return flat.rooms + ':a ' + flat.size + ' ㎡ på ' + flat.street + ' ' + flat.street_number + ' i ' + flat.city
      } else {
        return 'BytBostad'
      }
    },
    adDescription() {
      // Fabian's template 2026-09-22 – byte for byte what page_server.php (listingDescription)
      // puts in the first-pass HTML; a clause whose value is missing is left out. Change both.
      if (this.ad && this.ad.flats && this.ad.flats.length > 0) {
        var flat = this.ad.flats[this.showFlat]
        var t = s => (s === null || s === undefined ? '' : String(s).trim())
        var where = t(flat.hood) && t(flat.hood) !== t(flat.city) ? t(flat.hood) + ', ' + t(flat.city) : t(flat.city)
        var rent = parseInt(flat.rent, 10) || 0
        var floor = parseInt(flat.floor, 10) || 0
        var s = t(flat.rooms) + ':a på ' + t(flat.street) + ' ' + t(flat.street_number) + ' i ' + where +
          (rent > 0 ? ' med en hyra på ' + String(rent).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kronor' : '') +
          ' finns tillgänglig för lägenhetsbyte.'
        if (t(flat.size)) {
          s += ' Lägenheten är ' + t(flat.size) + ' kvadratmeter stor' + (floor > 0 ? ' och ligger på våning ' + floor : '') + '.'
        }
        if (t(flat.landlord)) {
          s += ' Hyresvärd är ' + t(flat.landlord) + '.'
        }
        return s
      }
      return ''
    },
    ogPhoto() {
      if (this.ad && this.ad.flats && this.ad.flats.length > 0 && this.currentFlat && this.currentFlat.photos && this.currentFlat.photos.length) {
        return 'https://bytbostad.se/bilder/share/' + this.currentFlat.photos[0].img_url + '.jpg'
      } else {
        return 'https://bytbostad.se/img/share.jpg'
      }
    },
    currentFlat() {
      return this.ad && this.ad.flats ? this.ad.flats[this.showFlat] : undefined
    },
    modalStyle() {
      if (this.opener !== 'modal') {
        // return 'margin-top:74px;'
        return ''
      } else {
        return 'modalstyle'
      }
    },

    showmap() {
      if (this.ad && this.ad.lat && this.ad.lng && this.adLoaded) {
        return true
      } else {
        return false
      }
    },

    shareURL() {
      return 'https://bytbostad.se/bostad/' + this.id
    },

    getLikeStatus() {
      if (this.myActiveAd && this.ad && this.ad.id) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    '$route.params.id': function(id) {
      // console.log(id)
      this.getAd(id)
      this.routeKey = id
    },
    getLikeStatus(newStatus) {
      if (newStatus === true) {
        this.likeOrPass()
      }
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  created() {
    this.getAd(this.id)
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted() {
    // console.log('Monterad')
    // console.log(this.ad)
  },
  methods: {
    removeMatch() {
      const _this = this
      this.$swal.fire({
        title: 'Är du säker?',
        // text: 'Om du tar bort matchningen k',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ff7660',
        // cancelButtonColor: '#61bbb2',
        cancelButtonText: 'Avbryt',
        confirmButtonText: 'Ja, ta bort matchningen!'
      }
      ).then((result) => {
        if (result.value) {
          _this.passcard()
        }
      })
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },

    youNeedAnAd() {
      this.$swal
        .fire({
          title: 'Du har ingen annons!',
          text:
            'För att kunna anmäla intresse eller ointresse på bostäder på BytBostad behöver du ha en annons!',
          type: 'info',
          showCancelButton: false,
          confirmButtonColor: '#64BCB2',
          // cancelButtonColor: '#61bbb2',
          confirmButtonText: 'Skapa annons!',
          cancelButtonText: 'Avbryt'
        })
        .then(result => {
          if (result.value) {
            // console.log(result.value)
            this.$router.push({ name: 'create-ad' })
          } else {
            // console.log(result.value)
          }
        })
    },
    youNeedMembership() {
      this.$swal
        .fire({
          title: 'Aktivera ditt konto',
          text:
            'För att kunna anmäla intresse på bostäder på BytBostad behöver du ha ett aktivt medlemskap!',
          // type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#64BCB2',
          // cancelButtonColor: '#61bbb2',
          confirmButtonText: 'Aktivera ditt konto',
          // cancelButtonText: 'Avbryt'
        })
        .then(result => {
          if (result.value) {
            // console.log(result.value)
            this.$router.push({ name: 'checkout' })
          } else {
            // console.log(result.value)
          }
        })
    },

    handleCardAccepted(id) {
      if (this.myActiveAd) {
        AdService.likeAd(this.myActiveAd, id, 1).then(res => {
          // console.log(res.data)
          if (res.data.data === 'NO_MEMBERSHIP') {
            // alert('Saknar medlemskap')
            this.youNeedMembership()
          }else if (res.data.data === 'TOO_MANY_LIKES') {
            // alert('Saknar medlemskap')
            this.youNeedMembership()
          }

            this.likeOrPass()
          
        }).catch(err => {
          Sentry.captureException(err)
          this.$posthog.captureException(err)
        })
      } else {
        this.youNeedAnAd()
      }
      // AdService.likeProspect
    },
    handleCardRejected(id) {
      const _this = this
      if (this.myAds.length === 1) {
        AdService.passAd(this.myActiveAd, id, 0).then(res => {
          // console.log(res.data)
          _this.$store.dispatch('getMatches', this.myActiveAd).catch(() => {})
          this.likeOrPass()
        }).catch(err => {
          Sentry.captureException(err)
          this.$posthog.captureException(err)
        })
      } else {
        this.youNeedAnAd()
      }
    },

    likecard() {
      if (this.opener === 'modal') {
        this.$emit('likecard')
      } else {
        this.handleCardAccepted(this.ad.id)
      }
      // this.getAd(this.id)
      this.$store.dispatch('getMatches', this.myActiveAd).catch(() => {})
      // console.log('Like the card from AD with ' + this.opener)
    },
    passcard() {
      // console.log('Pass the card from AD with ' + this.opener)

      if (this.opener === 'modal') {
        this.$emit('passcard')
      } else {
        this.handleCardRejected(this.ad.id)
      }
      // this.getAd(this.id)
    },
    FBShare() {
      //   console.log('Share on facebook')
      //   FB.ui({
      //   method: 'share',
      //   href: 'https://nya.bytbostad.se'
      // }, function(response){});
      var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,'
      window.open('https://www.facebook.com/sharer/sharer.php?u=https://bytbostad.se/bostad/' + this.id, '', options + 'height=300,width=600')
    },
    toggleflat(index) {
      // alert(index)
      this.showFlat = index
    },

    setAd(ad) {
      this.ad = ad
      // API sometimes returns flats: null — always ensure it's an array
      if (!Array.isArray(this.ad.flats)) {
        this.$set(this.ad, 'flats', [])
      }
      this.center = {
        lat: parseFloat(ad.lat),
        lng: parseFloat(ad.lng)
      }
      this.adLoaded = true
    },
    getAd(id) {
      // Shown at once from the page itself; the API call below still runs, since only it
      // knows the visitor (mine, as_user). Without this the page depended on that second
      // request, which Google's renderer often never makes – and its failure meant /404,
      // filed by Google as a redirect (13 600 listings out of the index, October 2026).
      const embedded = takeEmbeddedListing(id)
      if (embedded) {
        this.setAd(embedded)
      }
      AdService.getAd(id)
        .then(response => {
          if (!response.data.data) { // the API's own "no such ad"
            this.$router.push({ name: '404' }).catch(() => {})
            return
          }
          this.setAd(response.data.data)
        })
        .catch(error => {
          // Only a listing that really is gone leaves the page; a timeout or a blocked request
          // keeps what page_server.php gave us.
          const gone = error.response && error.response.status === 404
          if (gone || !embedded) {
            this.$router.push({ name: '404' }).catch(() => {})
          }
        })
    },
    likeProspect() {
      // console.log('Likeprospect from Ad.vue')
      if (this.opener === 'modal') {
        // console.log('Opener was modal')

        // console.log('Modal like')
        // console.log(this.ad.id)
        // this.$emit('closeModal')
        this.$emit('likecard')
      } else {
        // console.log('No opener')
        this.$store.dispatch('likeProspect', this.ad.id)
      }
    },
    passProspect() {
      if (this.opener === 'modal') {
        this.$emit('passcard')
      } else {
        this.$store.dispatch('passProspect', this.ad.id)
      }
    },
    editPhotos() {
      this.$router.push({ name: 'ad-photos', params: { adid: this.ad.id, flatid: this.ad.flats[this.showFlat].id } })
    },
    close() {
      this.$router.go(-1)
    },
    adIsLoaded() {
      this.adLoaded = true
    },
    deleteAd(id) {
      this.$swal
        .fire({
          title: 'Är du säker?',
          text:
            'Om du raderar annonsen så försvinner alla dina matchningar, bilder mm. för denna annonsen',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#ff7660',
          // cancelButtonColor: '#61bbb2',
          confirmButtonText: 'Ja, radera annonsen!',
          cancelButtonText: 'Avbryt'
        })
        .then(result => {
          if (result.value) {
            // console.log('Ta bort annonsen')
            AdService.deleteAd(id)
              .then(() => {
                this.$store.commit('SET_MY_ADS', [])
                this.$store.dispatch('getMyAds')
                this.$router.push({ name: 'create-ad' })
              })
              .catch(error => {
                Sentry.captureException(error);
                // this.errors = error
              })
          }
        })
    },

    likeOrPass() {
      if (this.myActiveAd !== this.ad.id) {
        AdService.getLikeStatus(this.myActiveAd, this.ad.id).then(res => {
        // console.log('Done!')
        // console.log(res.data.data)
          this.interest = res.data.data
        }).catch(error =>{
          Sentry.captureException(error);
        })
      }
      // console.log(
      //   {
      //     from_ad_id: this.myActiveAd,
      //     to_ad_id: this.ad.id
      //   }
      //   )
      // bbaxios.get('me')
    }
  },

  metaInfo() {
    return {
      title: this.adTitle,
      meta:[
        {
            vmid: 'og:image',
            property: 'og:image',
            name: 'image',
            content: this.ogPhoto,
        },
        {
            vmid: 'og:image:width',
            property: 'og:image:width',
            content: '1200', // /bilder/share/ is 1200×630
        },
        {
            vmid: 'og:image:height',
            property: 'og:image:height',
            content: '630',
        },
        {
            vmid: 'og:title',
            property: 'og:title',
            content: this.adTitle
          },
        // Same text as page_server.php writes for this listing (do not "improve" one side only).
        { vmid: 'description', name: 'description', content: this.adDescription },
        { vmid: 'og:description', property: 'og:description', content: this.adDescription },
        { vmid: 'og:type', property: 'og:type', content: 'article' }

      ]
      // meta: [
      //     {
      //       vmid: 'og:title',
      //       property: 'og:title',
      //       content: this.adTitle,
      //       template: '%s - BytBostad'
      //     },
      //     {
      //       vmid: 'og:image',
      //       property: 'og:image',
      //       content: this.ogPhoto,
      //     }
      // ]
      // meta: [
      // // {http-equiv: 'Content-Type', content: 'text/html; charset=utf-8'},
      // // { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      // { name: 'og:image', content: 'https://bytbostad.se/bilder/large/' + this.currentFlat.photos[0].img_url }

      // ]
    }
  }
}

</script>

<style lang="scss" scoped>

@import '@/scss/main.scss';

@import '@/scss/abstracts/_variables.scss';
@import '@/scss/abstracts/_mixins.scss';

.archived-top-space{
  height: 10px;
}
.archived-notice{
  background-color: #fff8e1;
  border: 1px solid #f0d98c;
  border-radius: 8px;
  padding: 14px 16px;
  margin: 16px 0;
  line-height: 1.4;

  strong{ display: block; }
}
.share-url{
  background-color:white;
font-family: 'Source Code Pro', monospace;
      text-align: center;
    padding: 12px;
  // font-size:10px;

  font-size:12px;
  text-align:center;
  margin-bottom:22px;
  border-radius: 8px;
}

.extra-bottom{
        @include breakpoint(small down){

  padding-bottom:100px;
        }
}
.ad-controls{
      @include breakpoint(small down){

  position: fixed;
    bottom: 0;
    width: 100%;
    padding: 20px;
    height: 180px;
    // backdrop-filter: blur(10px);
      }
      .button-card{
        // box-shadow: 0px 0px 15px grey !important;
         box-shadow:
  0 2.8px 2.2px rgba(0, 0, 0, 0.034),
  0 6.7px 5.3px rgba(0, 0, 0, 0.048),
  0 12.5px 10px rgba(0, 0, 0, 0.06),
  0 22.3px 17.9px rgba(0, 0, 0, 0.072),
  0 41.8px 33.4px rgba(0, 0, 0, 0.086),
  0 100px 80px rgba(0, 0, 0, 0.12)
;
      }
}
$responsive-card-table-bottom-gap: 1.5rem;
$responsive-card-table-border: 1px solid black;
$responsive-card-table-stack-point: 640px;
$responsive-card-table-label-bg: gray;

.responsive-card-table {
  border-collapse: collapse;
  font-size:12px;
  background-color:white;
  margin-bottom:20px;

  &.unstriped tbody {
    background-color: transparent;
  }

  th {
    background-color: $responsive-card-table-label-bg;
  }

  tr,
  th,
  td {
    border: $responsive-card-table-border;
  }

td{
  padding:5px;
}
  @media screen and (max-width: $responsive-card-table-stack-point) {
    thead tr {
      position: absolute;
      top: -9999em;
      left: -9999em;
    }

    tr {
      border: $responsive-card-table-border;
      display: block;
    }

    tr + tr {
      margin-top: $responsive-card-table-bottom-gap;
    }
    /* Get table cells to act like rows */

    td {
      border: none;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: $responsive-card-table-border;
      padding-left: 50%;
      position: relative;

      &:before {
        content: attr(data-label);
        display: inline-block;
        font-weight: bold;
        line-height: 1.5;
        margin-left: -100%;
        width: 100%;
        position: relative;
        z-index: 1;
      }

      &:after {
        content: '';
        position: absolute;
        background: $responsive-card-table-label-bg;
        width: 45%;
        height: 95%;
        left: 1px;
        top: 1px;
        z-index: 0;
      }
    }
  }
}

.contact-info{
  display:grid;
  justify-items: center;
  align-items: center;
}

.not-a-member{

  background-color:white;
  margin-bottom: 20px;
    border-radius: 8px;
    padding: 20px;

border:5px solid #64bcb2;
p,h1,h2,h3,h4,ul,ol,li{
  margin-bottom:10px;
}
}

// .not-a-member p, .not-a-member ul, .not-a-member ol, .not-a-member li, .not-a-member h3, .not-a-member h1, .not-a-member h2{
//   margin-bottom:10px;
// }

.this-is-a-match{
  border:2px solid #ffb95c;
  // background-color:#ffb95c;
  // background-color: #ffdcad;
  background-color: white;;
  margin-bottom: 20px;
    border-radius: 8px;
    padding: 20px;
}
.this-is-a-match p, .this-is-a-match ul, .this-is-a-match ol, .this-is-a-match li, .this-is-a-match h3{
  margin-bottom:10px;
}
.facebook{
    background: url(/img/fb-white.svg);
    background-color: #3C5A99;
    background-repeat: no-repeat;
    background-repeat: no-repeat;
    background-size: 30px;
    background-position-y: 50%;
    background-position-x: 25px;

  background-color: #3C5A99;
  padding-left:65px;
}
.facebook:hover{
  background-color: rgb(94, 120, 177);
  /* border: 2px #8b9dc3; */
}
.closebar{
  background-color:white;
}
.flatswitcher{
  // border:1px solid black;

  padding: 20px 10px;
    background-color: #bfbfbf;
    text-align: center;
  //   cursor: pointer;
  //   transition: all 200ms ease-in-out;
  //   font-size: 19px;
  //   font-weight: 700;
    border-radius: 6px;
    margin-bottom:10px;

  //   background-clip: padding-box;

}
.flatswitcher:hover{
  cursor:pointer;
}
.flatswitcher.active{
  background-color:$color-secondary;
      color: #ffffff;

}


input.skipbb{
  // display:none;
  font-size:10px;
}
</style>
